import { useState, useEffect } from "react";
import BackMethods from "../../back_component/BackMethods";
import { useNavigate, useLocation } from "react-router-dom";

export default function FacilityTypeManagementPage() {
    const location = useLocation();
    const successMessage = location.state?.successMessage;
    const [deleteSuccessMessage, setDeleteSuccessMessage] = useState("");
    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();

    const [facilityTypes, setFacilityTypes] = useState([]);
    const [filteredTypes, setFilteredTypes] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [isLoading, setIsLoading] = useState(true);

    // جلب البيانات من السيرفر
    const fetchFacilityTypes = async () => {
        setIsLoading(true);
        try {
            const res = await backEnd_request.get("/FacilityTypes");
            // نفترض أن البيانات تعود كمصفوفة مباشرة بناءً على الكود القديم
            const data = Array.isArray(res.data) ? res.data : (res.data.data || []);
            setFacilityTypes(data);
            setFilteredTypes(data);
        } catch (error) {
            console.error("Fetch Error:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchFacilityTypes();
    }, []);

    // البحث المحلي
    const handleSearch = (term) => {
        setSearchTerm(term);
        if (!term.trim()) {
            setFilteredTypes(facilityTypes);
            return;
        }
        const filtered = facilityTypes.filter((type) =>
            type.name.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredTypes(filtered);
    };

    // الحذف
    const handleDelete = async (facilityTypeId) => {
        if (window.confirm("هل أنت متأكد من حذف هذا النوع؟")) {
            try {
                await backEnd_request.delete(`/FacilityTypes/${facilityTypeId}`);
                fetchFacilityTypes();
                setDeleteSuccessMessage("تم حذف نوع المنشأة بنجاح ✅");
                setTimeout(() => setDeleteSuccessMessage(""), 3000);
            } catch (error) {
                console.log(error.response?.data || error);
            }
        }
    };

    return (
        <div className="container py-5" style={{ maxWidth: '900px', direction: 'rtl' }}>

            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-5">
                <div>
                    <h2 className="fw-black m-0 text-dark">إدارة أنواع المنشآت</h2>
                    <p className="text-muted small mb-0">التحكم في تصنيفات المنشآت المتاحة في النظام</p>
                </div>
                <button
                    className="btn btn-dark rounded-pill px-4 fw-bold shadow-sm"
                    onClick={() => navigate("/admin/facilitytypes-management/create")}
                >
                    + إضافة نوع
                </button>
            </div>

            {/* Search */}
            <div className="mb-4">
                <div className="input-group bg-white rounded-4 shadow-sm border p-1">
                    <span className="input-group-text bg-transparent border-0 ps-3">
                        <i className="bi bi-search text-muted"></i>
                    </span>
                    <input
                        type="text"
                        className="form-control border-0 shadow-none py-3"
                        placeholder="ابحث عن نوع منشأة..."
                        value={searchTerm}
                        onChange={(e) => handleSearch(e.target.value)}
                    />
                </div>
            </div>

            {/* Success Messages */}
            {(successMessage || deleteSuccessMessage) && (
                <div className="alert alert-success rounded-4 border-0 shadow-sm text-center fw-bold mb-4">
                    {successMessage || deleteSuccessMessage}
                </div>
            )}

            {/* List Content */}
            {isLoading ? (
                <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>
            ) : (
                <div className="types-list animate-fade-in mb-5">
                    {filteredTypes.length > 0 ? (
                        filteredTypes.map((item) => (
                            <div key={item.facilityTypeId} className="modern-row bg-white border rounded-4 p-3 mb-2 d-flex align-items-center justify-content-between shadow-sm transition-all">
                                <div className="d-flex align-items-center gap-4">
                                    {/* أيقونة تعبيرية كبديل للكبسولة الرقمية لتمييز التصميم */}
                                    <div className="icon-box text-center bg-primary-subtle text-primary rounded-3 d-flex align-items-center justify-content-center" style={{ width: '50px', height: '50px' }}>
                                        <i className="bi bi-building fs-4"></i>
                                    </div>

                                    <div>
                                        <h6
                                            className="fw-bold mb-0 pointer-link fs-5"
                                            onClick={() => navigate(`/admin/establishments-list?facilityType=${encodeURIComponent(item.name)}`)}
                                        >
                                            {item.name}
                                        </h6>
                                        <small className="text-muted">عرض المنشآت التابعة لهذا النوع</small>
                                    </div>
                                </div>

                                <div className="d-flex gap-2">
                                    <button
                                        className="btn btn-outline-primary border-0 rounded-circle p-2"
                                        onClick={() => navigate(`/admin/facilitytypes-management/edit/${item.facilityTypeId}`)}
                                        title="تعديل"
                                    >
                                        <i className="bi bi-pencil-square fs-5"></i>
                                    </button>
                                    <button
                                        className="btn btn-outline-danger border-0 rounded-circle p-2"
                                        onClick={() => handleDelete(item.facilityTypeId)}
                                        title="حذف"
                                    >
                                        <i className="bi bi-trash3 fs-5"></i>
                                    </button>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="text-center py-5 bg-white rounded-4 border text-muted">
                            <i className="bi bi-inbox fs-1 d-block mb-2"></i>
                            لا توجد بيانات تطابق بحثك
                        </div>
                    )}
                </div>
            )}

            <style>{`
                .fw-black { font-weight: 900; }
                .transition-all { transition: all 0.3s ease; }
                .modern-row:hover { transform: translateY(-3px); border-color: #0d6efd !important; box-shadow: 0 10px 20px rgba(0,0,0,0.05) !important; }
                .pointer-link { cursor: pointer; transition: 0.2s; color: #1e293b; }
                .pointer-link:hover { color: #0d6efd !important; text-decoration: underline; }
                .animate-fade-in { animation: fadeIn 0.5s ease-in-out; }
                @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
            `}</style>
        </div>
    );
}